import type { SVGProps } from "react";

// Sticker illustrations and the moon mark (DESIGN.md: Imagery). Neon fill
// with charcoal lines. All decorative: they carry no information, so they are
// hidden from assistive technology.

const FILL = "var(--zsd-colors-primary)";
const LINE = "var(--zsd-colors-on-primary)";

type StickerProps = SVGProps<SVGSVGElement> & { size?: number };

function Svg({ size = 96, children, viewBox = "0 0 120 120", ...props }: StickerProps) {
  return (
    <svg width={size} height={size} viewBox={viewBox} aria-hidden="true" focusable="false" {...props}>
      {children}
    </svg>
  );
}

// A crescent: the outer circle (16,16 r12) minus a circle at (21,12 r10).
const CRESCENT = "M14.94 4.05A12 12 0 1 0 27.43 19.66A10 10 0 0 1 14.94 4.05Z";

/** Header and footer mark: a neon crescent, no wordmark. Matches favicon.svg. */
export const MoonMark = (p: StickerProps) => (
  <Svg viewBox="0 0 32 32" size={28} {...p}>
    <path d={CRESCENT} fill={FILL} />
  </Svg>
);

export const MoonSticker = (p: StickerProps) => (
  <Svg {...p}>
    <circle cx="60" cy="60" r="48" fill={FILL} stroke={LINE} strokeWidth="5" />
    <g fill="none" stroke={LINE} strokeWidth="4">
      <circle cx="44" cy="46" r="10" />
      <circle cx="74" cy="76" r="7" />
      <circle cx="78" cy="40" r="4" />
    </g>
    <circle cx="48" cy="82" r="3" fill={LINE} />
  </Svg>
);

export const RocketSticker = (p: StickerProps) => (
  <Svg {...p}>
    <g stroke={LINE} strokeWidth="5" strokeLinejoin="round" strokeLinecap="round" fill={FILL}>
      <path d="M48 86l-12 18 22-6z" />
      <path d="M72 86l12 18-22-6z" />
      <path d="M52 92c2 10 5 16 8 20 3-4 6-10 8-20z" />
      <path d="M60 10c18 14 24 38 18 76H42c-6-38 0-62 18-76z" />
      <circle cx="60" cy="48" r="10" fill={LINE} />
    </g>
    <circle cx="57" cy="45" r="3" fill={FILL} />
  </Svg>
);

export const StarSticker = (p: StickerProps) => (
  <Svg {...p}>
    <path
      d="M60 8l14 34 36 3-27 23 9 36-32-20-32 20 9-36L10 45l36-3z"
      fill={FILL}
      stroke={LINE}
      strokeWidth="6"
      strokeLinejoin="round"
    />
  </Svg>
);

export const RobotSticker = (p: StickerProps) => (
  <Svg {...p}>
    <g stroke={LINE} strokeWidth="5" strokeLinejoin="round" strokeLinecap="round" fill={FILL}>
      <path d="M60 12v14" fill="none" />
      <circle cx="60" cy="10" r="6" />
      <rect x="6" y="48" width="12" height="24" rx="5" />
      <rect x="102" y="48" width="12" height="24" rx="5" />
      <path d="M38 92v14h44V92" />
      <rect x="18" y="26" width="84" height="66" rx="16" />
      <circle cx="44" cy="54" r="8" fill={LINE} />
      <circle cx="76" cy="54" r="8" fill={LINE} />
      <path d="M44 76c10 7 22 7 32 0" fill="none" />
    </g>
  </Svg>
);
